var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 24,
    height: 24,
    transform: "translate(1272 497)",
    fill: "#b833cf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_409",
    "data-name": "Mask Group 409",
    transform: "translate(-1272 -497)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1270.285 495.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M7.8,24.857H19.628a1.742,1.742,0,0,0,1.79-1.878c-.737-6.479-5.133-6.372-5.133-9.265s4.453-2.732,5.132-9.265a1.746,1.746,0,0,0-1.79-1.878H7.8A1.747,1.747,0,0,0,6.011,4.45c.68,6.533,5.132,6.318,5.132,9.265s-4.4,2.786-5.132,9.265A1.742,1.742,0,0,0,7.8,24.857Z",
    fill: "none",
    stroke: "#b631cd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M18.391,23.143H9.061c-.836,0-1.071-.965-.485-1.562,1.419-1.438,4.282-2.468,4.282-4.117V12c0-1.064-2.036-1.875-3.3-3.6-.208-.284-.187-.686.341-.686H17.55a.406.406,0,0,1,.343.683c-1.241,1.728-3.321,2.534-3.321,3.6v5.464c0,1.636,2.984,2.518,4.307,4.118C19.412,22.228,19.225,23.143,18.391,23.143Z",
    fill: "#b833cf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeV);
export default __webpack_public_path__ + "static/media/time_v.76476ffd6ea5d92ecc76d0ce475ccdfa.svg";
export { ForwardRef as ReactComponent };